import { IBillingInfo } from "../types";

const billingDefault: IBillingInfo = {
  customerID: "",
  firstName: "",
  lastName: "",
  name: "",
  company: "",
  address1: "",
  address2: "",
  country: "US",
  city: "",
  state: "PA",
  zipCode: "",
  phone: "",
  email: "",
  emailVerify: ""
};

export default billingDefault;
